import React, { useEffect, useMemo, useState, useCallback } from 'react';
import PdfPane from './PdfPane';
import AiPane from './AiPane';
import PdfModal from './PdfModal';
import './AppLayout.css';

const AppLayout = ({ pdfData, currentPage, onPageChange }) => {
  const [activeTab, setActiveTab] = useState('ai');
  const [isLoadingAnswer, setIsLoadingAnswer] = useState(false);
  const [answerText, setAnswerText] = useState('');
  const [isPdfExpanded, setIsPdfExpanded] = useState(false);

  useEffect(() => {
    setActiveTab('ai');
    setIsLoadingAnswer(false);
    setAnswerText('');
    setIsPdfExpanded(false);
  }, [pdfData?.fileId]);

  const readingMode = useMemo(() => {
    if (activeTab !== 'ai') return false;
    return Boolean(isLoadingAnswer) || Boolean(String(answerText || '').trim());
  }, [activeTab, isLoadingAnswer, answerText]);

  const openPdf = useCallback(() => setIsPdfExpanded(true), []);
  const closePdf = useCallback(() => setIsPdfExpanded(false), []);

  return (
    <div
      className={[
        'content-container',
        readingMode ? 'reading-mode' : 'document-mode',
      ].join(' ')}
    >
      <PdfPane
        pdfData={pdfData}
        currentPage={currentPage}
        onPageChange={onPageChange}
        mode={readingMode ? 'reading' : 'document'}
        onExpand={openPdf}
      />

      <AiPane
        pdfData={pdfData}
        currentPage={currentPage}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        isLoadingAnswer={isLoadingAnswer}
        setIsLoadingAnswer={setIsLoadingAnswer}
        answerText={answerText}
        setAnswerText={setAnswerText}
      />

      <PdfModal
        open={isPdfExpanded}
        onClose={closePdf}
        pdfData={pdfData}
        currentPage={currentPage}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default AppLayout;
